import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// import PopupData from './popup/Popup.context';
import { actions as ppcActions } from '../../reducers/ppc.reducer';

// import PopupName from './popup/PopupName.react';
// import PopupDetails from './popup/PopupDetails.react';
// import PopupFiles from './popup/PopupFiles.react';
// import PopupParagraph from './popup/PopupParagraph.react';

// import RichTextEditor from 'react-rte';

import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Slide from './Slide.react';

// TODO :: Stop if app / type is not in constants
// TODO :: make call with pageID to get latest article
var Popup = function Popup() {
  var dispatch = useDispatch();
  var _useParams = useParams(),
    popupID = _useParams.popupID;
  var homeSlider = useSelector(function (s) {
    return s.ppc.construxHomeSlider;
  });
  useEffect(function () {
    dispatch({
      type: ppcActions.construxHomeSlider,
      payload: {}
    });
  }, []);

  // const [state, setState] = useState({
  // 	popup: {},
  // 	popupID: null,
  // 	app: '',
  // 	name: '',
  // 	title: '',
  // 	subtitle: '',
  // 	type: '',
  // 	published: {},
  // 	paragraph: RichTextEditor.createEmptyValue(),
  // 	files: [],
  // });

  // useEffect(() => {
  // 	const popup = Object
  // 		.values(cmsPopups)
  // 		.find(x => x._id === popupID);

  // 	if (popup) {
  // 		const publishedObj = {};
  // 		popup.published.forEach(x => {
  // 			if (x.isPublished)
  // 				publishedObj[x.clientEnv] = true;
  // 		});

  // 		setState({
  // 			popup,
  // 			popupID: popup._id,
  // 			app: popup.clientApp,
  // 			title: popup.title,
  // 			name: popup?.name || '',
  // 			subtitle: popup.subtitle,
  // 			type: popup.type,
  // 			published: publishedObj,
  // 			paragraph: popup.paragraph?.length > 0 ?
  // 				RichTextEditor
  // 					.createEmptyValue()
  // 					.setContentFromString(popup.paragraph, 'html') :
  // 				RichTextEditor.createEmptyValue(),
  // 			files: popup.files,
  // 		});
  // 	}
  // }, [popupID, cmsPopups]);

  console.log({
    homeSlider: homeSlider
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Landingpage Slider",
    button: {
      label: 'New Slide',
      type: 'add',
      // permission: 'edit-pos-sections',
      onClick: function onClick() {
        dispatch({
          type: ppcActions.construxHomeSlider,
          payload: {
            formData: {},
            method: 'post'
          }
        });
      }
    }
    // search={{
    // 	query: filter,
    // 	onChange: e => setFilter(e.target.value),
    // 	label: 'Search Sections:',
    // 	placeholder: 'Search...',
    // }}
  })), homeSlider === null || homeSlider === void 0 ? void 0 : homeSlider.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(Slide, {
      slide: x,
      key: 'slide' + x._id
    });
  }))));
};
export default Popup;